import { render, staticRenderFns } from "./Pencil.vue?vue&type=template&id=6854671e&"
import script from "./Pencil.vue?vue&type=script&lang=ts&"
export * from "./Pencil.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports